import Vue from 'vue'
import Cookies from 'js-cookie'
import DefaultLanguage from '@/core/js/DefaultLanguage'
import Settings from '@/config/Settings'

import Captations from '@/components/captation/Captations.js'

const route = {
  name: null,
  meta: {
    lang: DefaultLanguage,
    name: null
  }
}

export default {
  namespaced: true,
  state: {
    lang: DefaultLanguage,
    mode: Settings.mode,
    route: {
      from: route,
      to: route
    },

    isPlaying: true,
    about: false,
    captations: _.shuffle(Captations),
    orientation: window.innerHeight > window.innerWidth ? 'portrait' : 'landscape',
    conclusion: false,
    vr: false,
    fullscreen: false,
    levels: {
      'intro-3': '#fc1f1f',
      'explore': '#d559e2',
      1: '#d559e2',
      2: '#ff8a00',
      3: '#2588b1',
      4: '#5d64e3',
      5: '#a64545',
      6: '#9b6234',
      7: '#938733',
    },
  },
  mutations: {
    'SET_MODE' (state, mode) {
      state.mode = mode
    },
    'RESET_MODE' (state) {
      state.mode = Settings.mode
    },
    'SET_FROM_ROUTE' (state, from) {
      state.route.from = from
    },
    'SET_TO_ROUTE' (state, to) {
      state.route.to = to
    },
    'LANG_REFRESH' (state) {
      const l = state.lang
      state.lang = 'none'
      state.lang = l
    },
    'LANG_CHANGED' (state, lang) {
      state.lang = lang
      Cookies.set(Settings.cookies.lang, state.lang)
    },

    'SET_ORIENTATION'(state) {
      state.orientation = window.innerHeight > window.innerWidth || state.vr ? 'portrait' : 'landscape'
    },
    'SET_PLAYING'(state, bool) {
      state.isPlaying = bool
    },
    'CONCLUSION'(state) {
      state.conclusion = true
    },
    'RESET'(state, lang) {
      if(window.google_analytics && typeof window.google_analytics.gaTrack == 'function')
        _.each(Settings.ua_code, code => {
          window.google_analytics.gaTrack({ language: state.lang, name: "reload", ua_code: code, event: "reload_" + lang })
        })

      state.conclusion = false
      state.isPlaying = true
      _.each(state.captations, c => {
        c.viewed = false
        c.clicked = false
        c.isShow = false
      })
    },
    'SET_VR' (state, bool) { state.vr = bool },
    'SET_FULLSCREEN' (state, bool) { state.fullscreen = bool },
    'SET_ABOUT' (state, bool) { state.about = bool },
  },
  getters: {
    lang: state => state.lang,
    mode: state => state.mode,
    route: state => state.route,

    about: state => state.about,
    isPlaying: state => state.isPlaying,
    captations: state => state.captations,
    orientation: state => state.orientation,
    conclusion: state => state.conclusion,
    levels: state => state.levels,
    vr: state => state.vr,
    fullscreen: state => state.fullscreen
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/App.js